import { selectUserAddress } from 'modules/user/store/selectors';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectIsPersonalAccountInitialized,
  selectIsPersonalAccountInitializing,
  selectPersonalAccount,
  selectPersonalAccountUserEndpointToken,
  selectPersonalAccountWorkerToken,
} from '../store/selectors';

export const usePersonalAccountState = () => {
  const authAddress = useAppSelector(selectUserAddress);

  const isInitialized = useAppSelector(selectIsPersonalAccountInitialized);
  const isInitializing = useAppSelector(state =>
    selectIsPersonalAccountInitializing(state, authAddress!),
  );
  const personalAccount = useAppSelector(selectPersonalAccount);
  const userEndpointToken = useAppSelector(
    selectPersonalAccountUserEndpointToken,
  );
  const workerToken = useAppSelector(selectPersonalAccountWorkerToken);

  return {
    isInitialized,
    isInitializing,
    personalAccount,
    userEndpointToken,
    workerToken,
  };
};
